import vuewidget from './vuewidget'
import ZipWidgetPage from '@/pages/ZipWidgetPage.vue'

export default function (dom, opts) {
  // eslint-disable-next-line no-unused-vars
  const widget = vuewidget(dom, {
    vueComponent: ZipWidgetPage,
    vueInit: 'initGlobal',
    ...opts
  })
}
